import React, { useState } from "react";
import { COLORS } from "utils/styles";
import { getIconForUID } from "components/FormerEditor/utils";
import classnames from "classnames";
import { useHoverProps } from "utils/hooks";
import Image from "components/Image";
import { PRIORITY_FIT_COVER } from "utils/constants/ui";
import { DIMENSIONS } from "utils/constants/image";

const DEFAULT_CLASSES = {
  container: "pa3 bg-white pointer w-100",
  content: "flex flex-row justify-between items-center",
  option: "f5 flex flex-column"
};

const ProductOption = ({
  isLast,
  isActive,
  setActiveProduct,
  product,
  customClasses,
  hideActiveBorder,
  size
}) => {
  const ctxSize = size || 16;
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const [hover, setHover] = useState(false);
  const hoverProps = useHoverProps({ hover, setHover });
  const hasImage = Boolean(product.image);

  const Icon = getIconForUID("checkmark");

  const containerProps = {
    className: classnames(classes.container, {
      "bb hairline-1": !isLast,
      "bg-white": !hover || isActive,
      "bg-content--secondary": hover && !isActive,
      "fw5 ba--primary": isActive && !hideActiveBorder
    }),
    onClick: () => {
      setActiveProduct(product.id);
    },
    ...hoverProps
  };

  const visible = isActive || hover;
  let color = COLORS.deselected;
  if (isActive || hover) {
    color = isActive ? COLORS.blue : COLORS.deselected;
  }
  const icon = (
    <div className={`flex-shrink-0 ${visible ? "o-100" : "o-0"}`}>
      <Icon size={ctxSize} color={color} />
    </div>
  );

  return (
    <div {...containerProps}>
      <div className={classes.content}>
        <div className="flex flex-row items-start w-100">
          <div
            style={DIMENSIONS.PRODUCT_LIST_ITEM}
            className={classnames("br2 overflow-hidden flex-shrink-0", {
              "bg-whitesmoke": !hasImage
            })}
          >
            {hasImage ? (
              <Image
                src={product.image}
                {...DIMENSIONS.PRODUCT_LIST_ITEM}
                alt={product.name}
                {...PRIORITY_FIT_COVER}
              />
            ) : null}
          </div>
          <div className={"flex flex-column w-100 pl2"}>
            <div className="flex flex-row justify-between w-100">
              <div className="flex flex-column f5">
                <div className="f5 fw5">{product.name}</div>
                {product.priceRange && (
                  <div className="pt1 lh-title f6 black-80">
                    {product.priceRange}
                  </div>
                )}
              </div>
              {icon}
            </div>
            {product.description && (
              <div className="f6 pt2 lh-copy word-break">
                {product.description}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductOption;
